/**
 * @fileoverview GET handler for the "/engagement/jumpstart_content_blocks/:id" endpoint
 */
import fetch from "@lib/fetch";

import type { GetEngagementContentBlocksIdResult } from "../engagementContentBlocksId/types";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementJumpstartContentBlocks } from "./constants";

export const getEngagementJumpstartContentBlocks = reactQueryFetcherAdapter(
  engagementJumpstartContentBlocks,
  (signal: AbortSignal, id: string): Promise<GetEngagementContentBlocksIdResult> => {
    return fetch(`/engagement/jumpstart_content_blocks/${id}`, "GET", {}, { signal });
  }
);
